/* Aventus 4.3.4 (19 Oct 2026). Mark: "all images and text should reflect the languages appointed to that site" (approved
   adhoc-20261019-lang-p2). The list used to be stored under one key for every market, so a shopper who browsed /es-mx and then
   the US or UAE site saw Spanish cards with MXN prices in "Recently viewed". The list is now stored per market + language
   (the site root: '/', '/es-mx/', '/en-ae/'), and the old shared key is removed. Undo: restore this file from theme 4.3.3. */
if (typeof RecentProductsCache === 'undefined') {
  class RecentProductsCache {
    constructor() {
      this.limit = 10;
      this.key = RecentProductsCache.storageKey();
      try { localStorage.removeItem('theme:recently-viewed'); } catch (e) {}
      this.currentList = this.getCurrentListFromStorage();
    }

    static storageKey() {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
      return 'theme:recently-viewed:' + root + ':' + cur;
    }

    getCurrentListFromStorage() {
      try {
        const raw = localStorage.getItem(this.key);
        return JSON.parse(raw) || [];
      } catch (e) { return []; }
    }

    addProductsToStorage(container = document) {
      const elements = container.querySelectorAll('[data-recent-product-handle]');
      elements.forEach((el) => {
        const handle = el.dataset.recentProductHandle;
        const data = {
          handle,
          element: el.innerHTML,
        };
        const position = this.currentList.findIndex((item) => item.handle === handle);
        if (position === -1) {
          this.currentList = [data, ...this.currentList].slice(0, this.limit);
        } else {
          this.currentList = [data, ...this.currentList.filter((_, i) => i !== position)];
        }
      });
      try { localStorage.setItem(this.key, JSON.stringify(this.currentList)); } catch (e) {}
    }
  }

  window.RecentProductsCache = RecentProductsCache;
  window.recentProductsCache = new RecentProductsCache();
  window.recentProductsCache.addProductsToStorage();
}
